<template>
    <div class="container">
        <list
            table-classes="table is-fullwidth"
            :columns="columns"
            :data="events"
            :display-header="true"
            :page-length="50"
        >
            <slot slot-scope="{ item }">
                <tr
                    @click.stop="toggleExpanded(item.id)"
                    class="pointer"
                    :class="{
                        'remove-bottom-border': isExpanded(item.id),
                        'event-failed': eventFailed(item),
                    }"
                >
                    <td>{{ item.created_at }}</td>
                    <td>{{ item.path }}</td>
                    <td>{{ item.method }}</td>
                </tr>
                <tr v-if="isExpanded(item.id)">
                    <td colspan="3">
                        <div class="log-detail">
                            <div><b>Payload:</b></div>
                            <div>{{ item.payload }}</div>
                        </div>
                        <div class="log-detail">
                            <div><b>Response:</b></div>
                            <div>{{ item.response }}</div>
                        </div>
                    </td>
                </tr>
            </slot>
        </list>
    </div>
</template>

<script>
import List from '@elems/list'
export default {
    components: {
        List,
    },

    data() {
        return {
            events: [],
            expanded: [],
        }
    },

    computed: {
        columns() {
            return [
                { name: 'created_at', title: 'Time', sortable: true, searchable: true, width: 35 },
                { name: 'path', title: 'Path', sortable: true, searchable: true, width: 40 },
                { name: 'method', title: 'Method', sortable: true, searchable: true, width: 25 },
            ]
        }
    },

    created() {
        this.loadLog()
    },

    methods: {
        async loadLog() {
            const response = await axios.get('/api/integrations/economic/log')
            this.events = response.data
        },

        isExpanded(itemId) {
            return this.expanded.indexOf(itemId) >= 0
        },

        toggleExpanded(itemId) {
            if (this.isExpanded(itemId)) {
                this.expanded = this.expanded.filter(id => id !== itemId)
            } else {
                this.expanded.push(itemId)
            }
        },

        eventFailed(item) {
            return item.response.errorCode !== undefined
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~#/globals';

.pointer {
    cursor: pointer;
}
.remove-bottom-border td {
    border-bottom: none;
}
.event-failed td {
    background-color: $red;
    color: #FFF;
}
.log-detail {
    margin-top: 10px;
}
</style>
